// tslint:disable: max-line-length triple-equals
import React from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import moment from 'moment';
import { round } from 'lodash';
import { ANNONYMOUS_NAME } from '../../../utils/regex';
import { BottomSheet } from '../../../app/common/sharedComponents/BottomSheet';

export const Portal = (
  eqData,
  open,
  setOpen,
  showCom,
  setShowCom,
  showEq,
  setShowEq
) => {
  const getEqBgColor = (eqScore) => {
    if (eqScore == 5) {
      return '58C3BB';
    }
    if (eqScore == 4) {
      return 'ABE1DD';
    }
    if (eqScore == 3) {
      return 'F8E58A';
    }
    if (eqScore == 2) {
      return 'F79BA6';
    }
    if (eqScore == 1) {
      return 'CC3044';
    } else {
      return 'white';
    }
  };

  const labelValue = (value) => {
    switch (value) {
      case 1:
        return '1 Point- Extremely Dissatisfied';
      case 2:
        return '2 Points- Dissatisfied';
      case 3:
        return '3 points- Engaged';
      case 4:
        return '4 Points- Positively Engaged';
      case 5:
        return '5 Points - Completely Engaged';
      default:
        return '';
    }
  };
  if (!eqData) {
    return;
  }

  return (
    <BottomSheet isOpen={open} onClose={() => setOpen(false)}>
      <div className={`${showCom || showEq ? 'pt-190' : 'pt-30'} pb-70`}>
        <Block>
          <div className="text-center">
            <p className="fw-600 f-20 lh-24 color-58C3BB m-0">
              Emotional Intelligence
            </p>
            <span className="fw-400 f-12 lh-16 color-1F1F1F m-0">
              {eqData.time
                ? moment(eqData.time).format('Do MMM YY  HH:mm')
                : ''}
            </span>
            <p className="w-335px h-0 black-border-1" />
            <p className="fw-400 f-15 lh-20 color-1F1F1F m-0 mt-20 mb-20">
              <span className="w-40">Primary Emotion</span>{' '}
              <span
                className={`w-60 p-5 text-left ${eqData.templateEqValue ? '' : 'd-none'}`}
              >
                <span
                  className={`p-5 h-25px w-130px border-radius-10 lh-25 text-center f-15  ${eqData.templateEqValue ? 'background-' + getEqBgColor(round(eqData.templateEqValue)) : 'background-white'}`}
                >
                  {eqData.templateEqDescription
                    ? `${eqData.templateEqDescription}`
                    : ''}
                </span>
              </span>
            </p>
            <p className="fw-400 f-15 lh-20 color-1F1F1F m-0 w-80 ml-10p">
              {labelValue(round(eqData.templateEqValue))}
            </p>

            <div className={`p-10 ${showEq ? 'd-block' : 'd-none'}`}>
              {eqData.additionalText && (
                <>
                  <h5 className="text-left">Emotional Intelligence</h5>
                  <div className="fw-400 f-12 lh-16 color-1F1F1F m-0 text-left">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          eqData && typeof eqData.additionalText === 'string'
                            ? eqData.additionalText.replace(
                                ANNONYMOUS_NAME,
                                'employee'
                              )
                            : '',
                      }}
                    />
                  </div>
                </>
              )}
              {eqData.positiveText && (
                <>
                  <h5 className="text-left">Positive Aspects</h5>
                  <div className="fw-400 f-12 lh-16 color-1F1F1F m-0 text-left">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          eqData && typeof eqData.positiveText === 'string'
                            ? eqData.positiveText.replace(
                                ANNONYMOUS_NAME,
                                'employee'
                              )
                            : '',
                      }}
                    />
                  </div>
                </>
              )}
              {eqData.negativeText && (
                <>
                  <h5 className="text-left">Negative Aspects</h5>
                  <div className="fw-400 f-12 lh-16 color-1F1F1F m-0 text-left">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          eqData && typeof eqData.negativeText === 'string'
                            ? eqData.negativeText.replace(
                                ANNONYMOUS_NAME,
                                'employee'
                              )
                            : '',
                      }}
                    />
                  </div>
                </>
              )}
              {eqData.recommendText && (
                <>
                  <h5 className="text-left">Recommendations</h5>
                  <div className="fw-400 f-12 lh-16 color-1F1F1F m-0 text-left">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          eqData && typeof eqData.recommendText === 'string'
                            ? eqData.recommendText.replace(
                                ANNONYMOUS_NAME,
                                'employee'
                              )
                            : '',
                      }}
                    />
                  </div>
                </>
              )}
            </div>

            <u
              onClick={() => setShowEq(!showEq)}
              className="fw-400 f-12 lh-16 color-919191 m-0 text-underline"
            >
              {showEq ? 'Collapse' : 'See'} Narrative
            </u>
            <p className="w-335px h-0 black-border-1" />
            {eqData.depCommentary && (
              <>
                <p className="fw-600 f-20 lh-24 color-58C3BB m-0">
                  Compliancy Summary
                </p>
                <span className="fw-400 f-12 lh-16 color-1F1F1F m-0">
                  {eqData.time
                    ? moment(eqData.time).format('DD MMM YY - HH:mm')
                    : ''}
                </span>
                <p className="fw-400 f-17 lh-22 color-1F1F1F m-0">
                  {eqData.subName}
                </p>

                <div
                  className={`fw-400 f-12 lh-16 color-1F1F1F m-0 text-left ${showCom ? 'd-block' : 'd-none'}`}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        eqData &&
                        eqData.depCommentary &&
                        typeof eqData.depCommentary === 'string'
                          ? eqData.depCommentary.replace(
                              ANNONYMOUS_NAME,
                              'employee'
                            )
                          : '',
                    }}
                  />
                </div>

                <u
                  onClick={() => setShowCom(!showCom)}
                  className="fw-400 f-12 lh-16 color-919191 m-0 text-underline"
                >
                  {showCom ? 'Collapse' : 'See'} Narrative
                </u>
              </>
            )}
          </div>
        </Block>
      </div>
    </BottomSheet>
  );
};
